<template>
  <div class="mal-swiper" v-if="swiperSlideData.length>0">
    <div class="in-swiper">
      <swiper :options="swiperOption">
        <swiper-slide v-for="(slide,index) in swiperSlideData" :key="index"><a :href="slide.url===''?'javascript:void(0)':slide.url" target="_blank"><img :src="slide.imgSrc"></a></swiper-slide>
      </swiper>
      <div class="swiper-pagination" id = "p"></div>
    </div>

  </div>
</template>

<script>
    import { swiper, swiperSlide } from 'vue-awesome-swiper'
    import 'swiper/dist/css/swiper.css'

    export default {
        components: {
            'swiper' :swiper,
            'swiper-slide': swiperSlide
        },
        data() {
            let option = this.$store.state.malMainPageConfig.malSwiper.option;
            let autoplayObject = false;
            if(option.autoplay===true){
                autoplayObject={
                    delay:option.delay,//默认3秒切换一次
                    disableOnInteraction :false
                }
            }
            return {
                swiperSlideData:this.$store.state.malMainPageConfig.malSwiper.swiperSlide,

                swiperOption: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                    autoplay: autoplayObject,
                    speed: option.speed,
                    pagination: {
                        el: '#p',
                        clickable: true,
                        renderBullet: function (index, className) {
                            return '<span class="' + className + '" style="margin: 0 5px; width: 22px;height:6px;background: #FC8555;border-radius: 9px;outline:none"></span>';
                        }
                    },
                }
            }
        },
        computed:{
          
        }
    }
</script>

<style scoped lang="scss">
  .mal-swiper{
    display: flex;
    justify-content:center;
    height: 450px;
  }
  .in-swiper{
    position: relative;
    width:1200px;
    height:450px;
  }
  .mal-swiper img{
    width:1200px;
    height:450px;
  }
  .in-swiper .swiper-pagination {
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 100%;
  }
</style>
